var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { ref: "formRollQuantity" }, [
    _c("div", { staticClass: "emd-panel" }, [
      _c("div", { staticClass: "emd-panel__section" }, [
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("h2", { staticClass: "emd-text _color_default _type_caption" }, [
              _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
            ]),
            _c(
              "p",
              {
                staticClass: "emd-text _size_small _color_nonessential eu-mt_1",
              },
              [_vm._v(" " + _vm._s(_vm.$t("description")) + " ")]
            ),
          ]),
        ]),
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("div", { staticClass: "emd-form-group" }, [
              _c(
                "label",
                {
                  staticClass: "emd-label _required",
                  attrs: { for: "kitQuantity" },
                },
                [_vm._v(_vm._s(_vm.$t("kitQuantity")))]
              ),
              _c(
                "div",
                {
                  staticClass: "emd-select",
                  class: {
                    _state_error:
                      _vm.$v.form.kitQuantity.$invalid &&
                      _vm.$v.form.kitQuantity.$dirty,
                  },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.kitQuantity,
                          expression: "form.kitQuantity",
                        },
                      ],
                      attrs: { "data-testid": "kitQuantity", required: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "kitQuantity",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { selected: "", disabled: "" },
                          domProps: { value: null },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("placeholder")) + " ")]
                      ),
                      _vm._l(_vm.kits, function (kit) {
                        return _c(
                          "option",
                          { key: kit.value, domProps: { value: kit.value } },
                          [_vm._v(" " + _vm._s(kit.label) + " ")]
                        )
                      }),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "emd-select__arrow" }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }